import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';

import type { IListResponse } from '../../../../core/models/responses.models';
import type { ExternalSource } from '../models/external-sharing.models';

@Injectable({
  providedIn: 'root',
})
export class ApiExternalSharingService {
  private http = inject(HttpClient);

  getExternalSources(): Observable<IListResponse<ExternalSource>> {
    return this.http.get<IListResponse<ExternalSource>>(`/api/externalsource/`);
  }
}
